import ShowcaseStoryTypes from 'store/actionTypes/showcaseStory'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  current: {},
  pagination: {},
  filter: {},
  components: {
    list: [],
    pagination: {}
  }
}

const showcaseStory = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case ShowcaseStoryTypes.GET_SHOWCASE_STORIES_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case ShowcaseStoryTypes.GET_SHOWCASE_STORY_DETAIL_SUCCESS:
      return {
        ...state,
        current: payload
      }
    case ShowcaseStoryTypes.UPDATE_FILTER_SHOWCASE_STORY_SUCCESS:
      return { ...state, filter: payload }

    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default showcaseStory
